import {Entity} from 'draft-js';

const isJsonObject = jsonString => {
	try {
		var o = JSON.parse(jsonString);

		if (o && typeof o === 'object') {
			return true;
		}
	} catch (e) {}

	return false;
};

// The href attribute is preferred over the resolved `node.href` property so a relative or
// smart-link href is preserved verbatim; text nodes have no getAttribute, so fall back to .href.
const getHref = node => (node.getAttribute ? node.getAttribute('href') || node.href : node.href);

// Match by class-token membership, not exact string equality: Plate can add its own classes
// (selection, hover, etc.) to a node on blur, and an exact `===` would then miss the class and
// silently drop the entity (a card degraded to a plain LINK, or a mention lost entirely). This
// also keeps mention/inline-card/action-item detection consistent instead of mixing `===` and
// token checks. classList is undefined on text nodes, so fall back to the exact check there
// (where it is simply false).
const hasClass = (node, token) => (node.classList ? node.classList.contains(token) : node.className === token);

const getEntityId = node => {
	let entityId = undefined;
	const isMention = hasClass(node, 'slate-mention');
	const isActionItem = hasClass(node, 'slate-action_item');
	if (node instanceof HTMLAnchorElement) {
		const entityConfig = {};
		const isInlineCard = hasClass(node, 'slate-inline-card');
		if (isInlineCard) {
			// Jira smart-link (inline card) — keep it as its own entity type so the href is
			// preserved on the way back, matching the emit side in block.js (PIKA-542).
			entityConfig.href = getHref(node);
			entityId = Entity.__create('JIRA_INLINECARD', 'IMMUTABLE', entityConfig);
		} else if (node.dataset && node.dataset.mention !== undefined) {
			entityConfig.url = node.href;
			entityConfig.text = node.innerHTML;
			entityConfig.value = node.dataset.value;
			entityId = Entity.__create('MENTION', 'IMMUTABLE', entityConfig);
		} else {
			entityConfig.url = getHref(node);
			entityConfig.title = node.innerHTML;
			entityConfig.targetOption = node.target;
			entityId = Entity.__create('LINK', 'MUTABLE', entityConfig);
		}
	} else if (isMention) {
		const mentionData = node.getAttribute('data-slate-value');
		const hasDataObject = isJsonObject(mentionData);
		const mentionDataObject = hasDataObject
			? JSON.parse(mentionData)
			: {
					personId: node.getAttribute('data-slate-value'),
					name: node.innerHTML,
			  };

		entityId = Entity.__create('MENTION', hasDataObject ? 'IMMUTABLE' : 'SEGMENTED', {
			mention: mentionDataObject,
		});
	} else if (isActionItem) {
		entityId = Entity.__create('ACTION_ITEM', 'SEGMENTED', {
			checked: node.querySelector('[role=checkbox]').getAttribute('data-state') === 'checked',
		});
	}
	return entityId;
};

export default getEntityId;
